<template>

  <svg viewBox="0 0 24 24" role="presentation" focusable="false" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.182 7.244a.793.793 0 010 1.587h-.008a.794.794 0 010-1.587h.008z"/><path clip-rule="evenodd" d="M13.897 4.273a3.968 3.968 0 015.195 3.133l1.034.259a.793.793 0 010 1.538l-.985.247v.968a7.141 7.141 0 01-4.76 6.73v1.997a.793.793 0 11-1.587 0V17.51c-.263.03-.527.047-.794.047h-.793v1.587a.793.793 0 01-1.587 0v-1.587H5.591l-.874 1.248a.794.794 0 01-1.3-.91l1.094-1.564a.806.806 0 01.027-.038l7.384-10.537a3.968 3.968 0 011.975-1.484zM6.703 15.97h1.33a3.968 3.968 0 003.143-6.386l-4.473 6.386zM15.89 5.76a2.381 2.381 0 00-2.668.908l-1.105 1.576a5.553 5.553 0 01-.198 7.728H12a5.555 5.555 0 005.554-5.553V8.035a2.382 2.382 0 00-1.663-2.276z"/></svg>

</template>


<script>

  export default {"name":"icon-73f6bbea1f0dd3a908f38d4e96782d9b"}

</script>